





















































































import {
  Component, Prop,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ValidationProvider } from 'vee-validate';
import { has } from 'lodash';
import ApiErrorMixin from '@/mixins/api-error';
import { getImageDataUri } from '@/libs/file-upload';
import { PhotoUpload } from '@/models/photo';
import { ImageUploaderData } from '@/models/file';

@Component
export default class ImageUploader extends mixins(ApiErrorMixin) {
  $refs!: {
    uploader: InstanceType<typeof ValidationProvider>;
  }

  @Prop({
    type: String,
    default: null,
  })
  id!: string;

  @Prop({
    type: File,
    required: true,
  })
  file!: File;

  @Prop({
    type: Object,
    default: null,
  })
  rules!: object;

  @Prop({
    type: Object,
    default: null,
  })
  customMessages!: object;

  @Prop({
    type: Boolean,
    default: false,
  })
  restore!: boolean;

  @Prop({
    type: String,
    default: null,
  })
  pageCode!: string;

  @Prop({
    type: String,
    default: null,
  })
  uploadPath!: string;

  uploadStatus = 'pending';

  errorMessage: string | null = null;

  localFile: File | null = this.file;

  fileData: ImageUploaderData | null = null;

  previewPath: string | ArrayBuffer | null = null;

  get validateRules() {
    return {
      ...this.rules,
    };
  }

  get isPending() {
    return this.uploadStatus === 'pending';
  }

  get isUploading() {
    return this.uploadStatus === 'loading';
  }

  get isError() {
    return this.uploadStatus === 'error';
  }

  get isSuccess() {
    return this.uploadStatus === 'success';
  }

  get validateName() {
    return this.fileData ? this.fileData.filename : '上傳的檔案';
  }

  async getPreviewImage(file: File) {
    const preivew = await getImageDataUri(file);
    this.fileData = preivew;
    this.previewPath = preivew.path;
  }

  async uploadFile() {
    this.uploadStatus = 'loading';
    try {
      const formData = new FormData();
      formData.append('page', this.pageCode);
      formData.append('photo', this.file);

      const { data: fileUploadResponse } = await this.$axios.post<{
        code: number;
        photo: PhotoUpload;
      }>(this.uploadPath, formData);

      if (fileUploadResponse.code === 0) {
        this.$emit('uploaded', {
          id: this.id,
          file: this.file,
          photo: fileUploadResponse.photo,
        });
        this.uploadStatus = 'success';
      } else {
        console.log(fileUploadResponse.code);
        this.errorMessage = this.apiErrorMapper(fileUploadResponse.code, {
          441: '請檢查圖片格式。',
          442: '請檢查圖片尺寸。',
          443: '上傳的圖片超過大小限制（2 MB）。',
        });
        this.$emit('failed', {
          id: this.id,
          file: this.file,
          message: this.errorMessage,
        });
        this.uploadStatus = 'error';
      }
    } catch (error) {
      this.uploadStatus = 'error';
      console.error(error);
    }
  }

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-explicit-any
  hasFailedRule(failedRules: any, ruleName: string) {
    return has(failedRules, ruleName);
  }

  restoreClickHandler() {
    this.$emit('restore');
  }

  onDeleteClick() {
    this.$emit('delete', {
      id: this.id,
    });
  }

  mounted() {
    this.$nextTick(async () => {
      if (!this.localFile) {
        return;
      }

      const result = await this.$refs.uploader.validate([
        this.localFile,
      ]);

      this.getPreviewImage(this.localFile);
      if (result.valid === true) {
        this.uploadFile();
      }
    });
  }
}
